import {
    RuleConditionType,
    TransactionRuleCondition,
    TransferRuleDirection,
} from "../../types/transactionRule";

export class TransactionRuleConditionDto {
    id: string;
    conditionType: RuleConditionType;
    value: TransactionRuleCondition["value"];
    transferDirection: TransferRuleDirection | null;

    constructor(condition: TransactionRuleCondition) {
        this.id = condition.id;
        this.conditionType = condition.conditionType;
        this.value = condition.value;
        this.transferDirection = condition.transferDirection;
    }

    static deserialize(
        dto: TransactionRuleConditionDto,
    ): TransactionRuleCondition {
        return {
            id: dto.id,
            conditionType: dto.conditionType,
            value: dto.value,
            transferDirection: dto.transferDirection,
        };
    }
}
